import { BasePolicyEditDefinition } from "./base-policy-edit.component";
import {
  AutoConfirmPolicy,
  DesktopAutotypeDefaultSettingPolicy,
  DesktopAutotypeGaPolicy,
  FillAssistPolicy,
  MasterPasswordPolicy,
  OrganizationDataOwnershipPolicy,
  OrganizationUserNotificationPolicy,
  PasswordGeneratorPolicy,
  RemoveUnlockWithPinPolicy,
  RequireSsoPolicy,
  ResetPasswordPolicy,
  RestrictedItemTypesPolicy,
  SendControlsPolicy,
  SingleOrgPolicy,
  TwoFactorAuthenticationPolicy,
  UriMatchDefaultPolicy,
} from "./policy-edit-definitions";

/**
 * The policy register for OSS policies.
 * Add your policy definition here if it is under the OSS license.
 */
export const ossPolicyEditRegister: BasePolicyEditDefinition[] = [
  new TwoFactorAuthenticationPolicy(),
  new MasterPasswordPolicy(),
  new RemoveUnlockWithPinPolicy(),
  new ResetPasswordPolicy(),
  new PasswordGeneratorPolicy(),
  new SingleOrgPolicy(),
  new RequireSsoPolicy(),
  new OrganizationDataOwnershipPolicy(),
  new SendControlsPolicy(),
  new RestrictedItemTypesPolicy(),
  // Autotype MVP only: only displayed when the Autotype MVP feature flag is on and GA is off
  new DesktopAutotypeDefaultSettingPolicy(),
  // Autotype GA only: only displayed when the Autotype GA feature flag is on and MVP is off
  new DesktopAutotypeGaPolicy(),
  new UriMatchDefaultPolicy(),
  new FillAssistPolicy(),
  new AutoConfirmPolicy(),
  new OrganizationUserNotificationPolicy(),
];
